import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { useTranslation } from 'react-i18next';
import type { components } from '../../../Api/types/openapi';

type AppVersionResponse = components['schemas']['AppVersionResponse'];

interface DeleteConfirmModalProps {
  isOpen: boolean;
  toggle: () => void;
  version: AppVersionResponse | null;
  onConfirm: () => void;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  toggle,
  version,
  onConfirm,
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>{t('Confirmar Eliminación')}</ModalHeader>
      <ModalBody>
        <p>
          {t('¿Estás seguro de que deseas eliminar la versión')}{' '}
          <strong>{version?.version || `ID: ${version?.id}`}</strong>?
        </p>
        <p className="text-danger">
          <small>{t('Esta acción no se puede deshacer.')}</small>
        </p>
      </ModalBody>
      <ModalFooter>
        <Btn color="secondary" onClick={toggle}>
          {t('Cancelar')}
        </Btn>
        <Btn color="danger" onClick={onConfirm}>
          {t('Eliminar')}
        </Btn>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteConfirmModal;

